<div class="general-label-container" *ngIf="!isLoadingLabels && !isLoadingLabelLoad">
	<div class="search" *ngIf="selectedLabel.id == '-1'">
		<cpi-input-with-autocomplete
			[availableOptions]="labelLoadIAC"
			[minInputLength]="3"
			[placeholder]="labels.lbl_geral_buscar + '. ' + labels.lbl_iac_min_char_search.replace('$__$', '3') + '.'"
			[keepValue]="false"
			(onValueChange)="setLabel($event)">
		</cpi-input-with-autocomplete>

		<cpi-msp-table
			[header]="searchHeader"
			[body]="labelLoad"
			[height]="'40dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			(getSort)="sort($event['sortDown'])"
			(getSelectedItem)="setLabel($event[0]['id'])">
		</cpi-msp-table>
	</div>

	<ng-container *ngIf="selectedLabel.id != '-1'">
		<div class="header-wrap">
			<span class="tab selected">Labels</span>
		</div>
		<div class="body-wrap">
			<ng-container>
				<ng-container>
					<div class="input-container">
						<span class="left-input">lbl_</span> <span class="title">{{ labels.lbl_geral_nome }}</span>
					</div>
					<input [value]="selectedLabel.id" (input)="selectedLabel.id = $event.target.value" />

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_portugues }}</span>
						<input [value]="selectedLabel.portuguese" (input)="selectedLabel.portuguese = $event.target.value" />
					</div>
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_ingles }}</span>
						<input [value]="selectedLabel.english" (input)="selectedLabel.english = $event.target.value" />
					</div>
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_espanhol }}</span>
						<input [value]="selectedLabel.spanish" (input)="selectedLabel.spanish = $event.target.value" />
					</div>
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_eslovaco }}</span>
						<input [value]="selectedLabel.slovak" (input)="selectedLabel.slovak = $event.target.value" />
					</div>
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_chines }}</span>
						<input [value]="selectedLabel.chinese" (input)="selectedLabel.chinese = $event.target.value" />
					</div>
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_italiano }}</span>
						<input [value]="selectedLabel.italian" (input)="selectedLabel.italian = $event.target.value" />
					</div>
				</ng-container>

				<div class="button-container">
					<div
						class="button"
						[ngClass]="{ disabled: isCreatingLabel || isUpdatingLabel }"
						(click)="cleanForm()"
						*ngIf="selectedLabel.id != '-1'">
						{{ labels.lbl_geral_limpar_campos }}
					</div>
					<div
						class="button"
						[ngClass]="{ disabled: isUpdatingLabel }"
						(click)="updateLabel()"
						*ngIf="selectedLabel.id != '-1' && crudType === 'update'">
						{{ labels.lbl_geral_atualizar }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isUpdatingLabel"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			</ng-container>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect
	[color]="'var(--primary-color-1)'"
	*ngIf="isLoadingLabels || isLoadingLabelLoad"></cpi-dot-bounce-loading-effect>
